import { z } from 'zod';

export const VerticalKey = z.enum([
  'cruise',
  'cold-chain',
  'specialty-distribution',
  'plumbing-manufacturing',
  'custom',
]);

export const TradecraftModule = z.object({
  id: z.string(),
  vertical: VerticalKey,
  topic: z.string(),
  body: z.string(),
  factsCited: z.array(z.string()),
  authoredBy: z.enum(['operator', 'llm-synthesized']),
  synthesizedConfidence: z.number().min(0).max(1).nullable(),
  reviewedByOperatorAt: z.string().nullable(),
  active: z.boolean().default(false),
  versionedAt: z.string(),
  correlationId: z.string(),
});
